import { estimateDescription } from './estimate-description';

type InvoiceSummary = { summary?:string|null; summaryRequired?:boolean|number; fulfillment?:string|null };
export function serviceCallSummaryRequired(invoice?:InvoiceSummary) {
  return invoice?.summaryRequired == null ? invoice?.fulfillment !== 'later' : Boolean(invoice.summaryRequired);
}
export function invoiceNeedsSummary(invoice?:InvoiceSummary) {
  return serviceCallSummaryRequired(invoice) && !estimateDescription(invoice?.summary).replace(/[\u200B-\u200D\uFEFF]/g,'').trim();
}
